import React, { useState } from "react";

import theme, {
  navbarHeight,
  roundness,
  styles as commonStyles,
} from "../../../utils/styles";

import Slide from "react-reveal/Slide";

// import data from "../../../data/contact";

const Contact = (props) => {
  const { yOffset, sectionIndex, isBreakpoint } = props;
  const documentHeight = window.innerHeight * sectionIndex;
  let scrolledInPercentage = Math.floor((yOffset / documentHeight) * 100);

  // console.log(scrolledInPercentage);

  const [hover, setHover] = useState(false);
  const [ShowConfirmation, setShowConfirmation] = useState(false);

  // const mailto = "mailto:";
  // const emailAddress = data.email;
  // const subjectPrefix = "?subject=";
  // const bodyPrefix = "?body=";

  // const emailContent = {
  //   name: "",
  //   subject: "",
  //   body: "",
  // };

  // const url =
  //   mailto +
  //   emailAddress +
  //   subjectPrefix +
  //   emailContent.name +
  //   " | " +
  //   emailContent.subject +
  //   bodyPrefix +
  //   emailContent.body;

  return (
    <div style={styles(isBreakpoint).root} id="#contact">
      <Slide when={scrolledInPercentage > 90} left>
        <div style={styles(isBreakpoint).margin}>
          <div style={styles(isBreakpoint).card}>
            <div style={styles(isBreakpoint).headingContainer}>
              <div style={styles(isBreakpoint).containerPadding}>
                <div style={styles(isBreakpoint).headingGrid}>
                  <img
                    src="/img/icons/contact.svg"
                    alt="contact us"
                    style={styles(isBreakpoint).icon}
                  />
                  <div style={styles(isBreakpoint).heading}>
                    Let's get in touch!
                  </div>
                </div>
              </div>
            </div>
            <div style={styles(isBreakpoint).formContainer}>
              <div style={styles(isBreakpoint).containerPadding}>
                <form
                  autoComplete="off"
                  encType="text/plain"
                  style={styles(isBreakpoint).form}
                >
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Your name?"
                    style={styles(isBreakpoint).textInput}
                    required
                  />
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    placeholder="Subject?"
                    style={styles(isBreakpoint).textInput}
                    required
                  />
                  <textarea
                    type="text"
                    id="message"
                    name="message"
                    placeholder="What would you like to say?"
                    style={styles(isBreakpoint).textArea}
                    required
                  />
                  <input
                    type="submit"
                    value="Send"
                    style={commonStyles.ctaButton(hover)}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/";
                      setShowConfirmation(!ShowConfirmation);
                    }}
                    onMouseEnter={(e) => {
                      setHover(true);
                    }}
                    onMouseLeave={(e) => {
                      setHover(false);
                    }}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </Slide>
    </div>
  );
};

export default Contact;

const styles = (isBreakpoint) => {
  let iconHeight = 60;
  let textSize = 36;
  let rowGap = 30;
  let cardMarginHorizontal = navbarHeight;
  let cardMarginTop = 0;

  if (isBreakpoint) {
    iconHeight /= 2;
    textSize /= 2;
    cardMarginHorizontal /= 2;
    cardMarginTop = navbarHeight * 1.5;
  }

  const textInputStyle = {
    width: isBreakpoint ? "100%" : "300px",
    borderStyle: "none",
    borderRadius: roundness.card,
    padding: isBreakpoint ? 10 : 12,
    fontSize: isBreakpoint ? 12 : 14,
    fontWeight: "bold",
    fontFamily: "arial",
  };

  return {
    root: {
      minHeight: "100vh",
      background: theme.colors.background,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    margin: {
      width: "80%",
      height: isBreakpoint ? "100%" : "80%",
      borderStyle: "solid",
      borderColor: "#ffffff00",
      borderWidth: `${cardMarginTop}px ${cardMarginHorizontal}px ${cardMarginHorizontal}px ${cardMarginHorizontal}px`,
    },
    card: {
      width: "100%",
      height: "100%",
      background: theme.gradients.theme,
      borderRadius: roundness.card,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      flexDirection: isBreakpoint ? "column" : "row",
    },
    containerPadding: {
      borderStyle: "solid none",
      borderColor: "#ffffff00",
      borderWidth: rowGap * 1.5,
    },
    headingContainer: {
      width: isBreakpoint ? "100%" : "50%",
      height: isBreakpoint ? "50%" : "100%",
    },
    formContainer: {
      width: isBreakpoint ? "100%" : "50%",
      height: isBreakpoint ? "50%" : "100%",

      background: "rgb(0,0,0,0.5)",

      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    headingGrid: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      rowGap: rowGap,
    },
    icon: {
      height: iconHeight,
    },
    heading: {
      fontWeight: "bold",
      fontSize: textSize,
      color: "white",
      textAlign: "center",
    },
    form: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      rowGap: rowGap,
    },
    textInput: {
      ...textInputStyle,
    },
    textArea: {
      ...textInputStyle,
      height: "20%",
      resize: "vertical",
    },
  };
};
